<template>
  <div class="common-table">
    <div class="common-table-header">
      <div class="common-table-header-left">
        <i></i> <span>{{ tableType }}</span>
      </div>
      <div class="common-table-header-export">
        <el-button
          style="width: 100px"
          type="primary"
          @click="download"
          size="mini"
          >表格下载</el-button
        >
      </div>
    </div>
    <div class="common-table-filter">
      <slot name="table-filter"></slot>
    </div>
    <div :class="['common-table-list', border ? 'has-border' : 'no-border']">
      <el-table
        :data="list"
        :border="border"
        stripe
        @sort-change="onSortChange"
      >
        <el-table-column
          v-for="item in keys"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :header-align="item.headerAlign"
          :sortable="item.sortable"
        >
          <template slot-scope="scope">
            <div class="school-name-type" v-if="item.prop === 'schoolName'">
              <span>{{ scope.row[item.prop] }}</span>
              <span
                v-if="scope.row.is430Active === 1"
                class="type-tip type-campus"
                >社团</span
              >
              <span
                v-if="scope.row.isCampusActive === 1"
                class="type-tip type-430"
                >校本</span
              >
            </div>
            <org-item
              v-else-if="item.component === 'org'"
              :col="item.prop"
              :row="scope.row"
            />
            <schedule-status
              v-else-if="item.component === 'status'"
              :innerText="scope.row[item.prop]"
            />
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column width="110" v-if="btns.length > 0">
          <template slot-scope="scope">
            <el-button
              v-for="(btn, index) in btns"
              :key="index"
              @click="btn.onClick(scope.row)"
              type="primary"
              size="small"
              >{{ btn.text }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="common-table-pagination">
      <Pagination
        :count="count"
        :page="pagingParams.page"
        :pageSize="pagingParams.pageSize"
        :pageSizeArr="[5, 10, 20, 50, 100]"
        @changePage="changePage"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <div v-if="needExport" class="school-table-export">
      <div>
        <span>校本学生总数：</span>
        <span>{{ exportStat.campusStudentCount || 0 }}</span>
      </div>
      <div>
        <span>社团学生总数：</span>
        <span>{{ exportStat.studentCount430 || 0 }}</span>
      </div>
      <div>
        <span>机构学生总数：</span>
        <span>{{ exportStat.orgStudentCount || 0 }}</span>
      </div>
      <div class="school-table-export-btn" @click="download">表格下载</div>
    </div>
  </div>
</template>

<script>
import Pagination from './Pagination'
import OrgItem from './custom/OrgItem'
import ScheduleStatus from './custom/ScheduleStatus'

export default {
  name: 'CommonTable',
  components: {
    Pagination,
    OrgItem,
    ScheduleStatus,
  },
  props: {
    tableType: {
      type: String,
      default: '',
    },
    keys: {
      type: Array,
      default() {
        return []
      },
    },
    count: {
      type: Number,
      default: 0,
    },
    list: {
      type: Array,
      default() {
        return []
      },
    },
    btns: {
      type: Array,
      default() {
        return []
      },
    },
    needExport: {
      type: Boolean,
      default: false,
    },
    exportStat: {
      type: Object,
      default() {
        return {}
      },
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pagingParams: {
        page: 1,
        pageSize: 10,
      },
    }
  },
  watch: {
    pagingParams(paging) {
      this.$emit('changePagingParams', paging)
    },
  },
  methods: {
    changePage(page) {
      this.pagingParams = {
        ...this.pagingParams,
        page,
      }
    },
    handleSizeChange(page) {
      this.pagingParams = {
        page: 1,
        pageSize: page,
      }
    },
    download() {
      this.$emit('download')
    },
    onSortChange({ prop, order }) {
      let orderText = ''
      if (order === 'descending') {
        orderText = 'desc'
      }
      if (order === 'ascending') {
        orderText = 'asc'
      }
      this.$emit('onSortChange', { order: orderText, orderBy: prop })
    },
  },
}
</script>

<style lang='scss'>
.common-table {
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 93, 0.1);
  border-radius: 4px;
  padding-bottom: 24px;
  .common-table-header {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    color: #333;
    border-bottom: 1px solid #e8e8e8;
    padding-right: 16px;
    padding-left: 16px;
    .common-table-header-left {
      display: flex;
      align-items: center;
      i {
        background-color: #2397f3;
        border-radius: 2px;
        width: 4px;
        height: 15px;
        margin-right: 10px;
      }
    }
  }
  .common-table-filter {
    padding-top: 24px;
    padding-left: 42px;
    padding-right: 42px;
    display: flex;
    .slot-box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .slot-box-left {
        display: flex;
      }
      .slot-box-right {
        display: flex;
      }
    }
    .select-com {
      margin-right: 20px;
    }
    .select-remote-com {
      margin-right: 20px;
    }
  }
  .common-table-list {
    margin-top: 20px;
    .el-button {
      padding: 9px 12px;
    }
  }
  .has-border {
    padding: 0 20px;
  }
  .no-border {
    .el-table {
      .el-table__header {
        tr {
          height: 60px;
        }
        .is-leaf {
          border-bottom: none;
        }
      }
      .el-table__row {
        height: 80px;
        td {
          border-bottom: none;
        }
      }
      tr {
        th:nth-of-type(1) {
          padding-left: 40px;
        }
        td:nth-of-type(1) {
          padding-left: 40px;
        }
      }
    }
  }
  .common-table-pagination {
    text-align: center;
    margin-top: 20px;
  }
  .school-table-export {
    display: flex;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
    color: #666;
    & > div {
      margin-right: 20px;
      span:last-child {
        color: #333;
      }
    }
    .school-table-export-btn {
      width: 114px;
      height: 32px;
      line-height: 30px;
      text-align: center;
      background-color: #ffffff;
      border-radius: 3px;
      border: solid 1px #2397f3;
      box-sizing: border-box;
      font-size: 14px;
      color: #2395f0;
      cursor: pointer;
      &:hover {
        opacity: 0.6;
      }
    }
  }
  .school-name-type {
    .type-tip {
      border-radius: 4px;
      font-size: 12px;
      color: #fff;
      padding: 2px 6px;
      margin-left: 4px;
      white-space: nowrap;
    }
    .type-campus {
      background-color: #f59a23;
    }
    .type-430 {
      background: #70b603;
    }
  }
}
</style>